<template>
  <div class="d-inline">
    <Button size="sm" @click="openModal">
      <b-spinner v-if="loading" small type="grow" class="text-muted mr-2"></b-spinner>
      <span :class="{ 'text-muted': loading }">Datos de Almacén</span>
    </Button>

    <b-modal v-model="modalShow" centered hide-footer scrollable @hide="reset">
      <template #modal-title>
        <span v-if="item" class="text-secondary">{{ item.item_code }}: Datos de Almacén</span>
      </template>
      <b-row align-h="center">
        <b-col class="px-0">
          <div v-if="loading" class=" text-center text-dark py-5 fs-14">
            <b-spinner small type="grow"></b-spinner>
            <span class="pl-2">Consultando SAP...</span>
          </div>
          <div v-else>
            <b-table
              v-if="warehouses.length > 0"
              bordered
              head-variant="dark"
              :fields="filteredFields"
              :items="filteredWarehouses"
              small
              responsive
              class="fs-13"
              thead-class="fs-10"
            >
              <template v-slot:cell(in_stock)="data">
                <div v-if="data.value > 0">
                  <span v-if="(isDistribution || isInstallation) && data.value > 30">30</span>
                  <span v-else>{{ data.value }}</span>
                </div>
              </template>
              <template v-slot:cell(committed)="data">
                <span v-if="data.value > 0">{{ data.value }}</span>
              </template>
              <template v-slot:cell(ordered)="data">
                <span v-if="data.value > 0">{{ data.value }}</span>
              </template>
            </b-table>
            <div v-else-if="pendingResult" class="text-center pb-3">
              <p class="text-danger fs-14">
                La operación tardó más de lo esperado
              </p>
              <Button class="mt-2" @click="ping">
                Intentarlo de nuevo
              </Button>
            </div>
            <!-- Dev only timestamp -->
            <small v-if="isDev && timestamp" class="text-info float-right pr-2">
              Última actualización {{ timestamp | formatDateTime }}
            </small>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Button from '../shared/Button'

export default {
  name: 'WarehouseDataModal',
  components: { Button },
  props: {
    item: {
      type: Object
    },
    isDistribution: {
      type: Boolean,
      default: false
    },
    isInstallation: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      warehouses: [],
      modalShow: false,
      timestamp: null,
      loading: false,
      processing: false,
      retryPingCount: 0,
      pendingResult: false,
      fields: [
        { key: 'code', label: 'Código', sortable: true, tdClass: 'text-center', thStyle: { width: '55px' } },
        { key: 'name', label: 'Nombre del almacén', sortable: true, tdClass: 'text-left fs-12' },
        { key: 'in_stock', label: 'En stock', sortable: true, tdClass: 'text-center', thStyle: { width: '70px' } },
        { key: 'committed', label: 'Comprometido', sortable: true, tdClass: 'text-center', thStyle: { width: '90px' } },
        { key: 'ordered', label: 'Pedido', sortable: true, tdClass: 'text-center', thStyle: { width: '70px' } }
      ]
    }
  },
  computed: {
    ...mapGetters (['isDev']),
    filteredWarehouses () {
      if (this.isDistribution) {
        return this.warehouses.filter(w => ['01', '08', '09', '10', '15', '31'].includes(w['code']))
      } else if (this.isInstallation) {
        return this.warehouses.filter(w => ['01', '31'].includes(w['code']))
      } else {
        return this.warehouses
      }
    },
    filteredFields () {
      const allowedPublicFields = ['code', 'name', 'in_stock']
      if (!this.isDistribution && !this.isInstallation) {
        return this.fields
      }
      return this.fields.filter(f => allowedPublicFields.includes(f.key))
    }
  },
  methods: {
    openModal () {
      if (this.loading) { return }
      this.loading = true
      this.modalShow = true
      this.$http.get(`/api/production/products/${this.item.id}/fetch_warehouses`, {
        params: {
          fetch_sap: true
        }
      })
        .then((res) => {
          // console.log(res)
          if (res.data.success) {
            this.warehouses = res.data.warehouses
            this.timestamp = res.data.timestamp
            const { stock, ordered_quantity } = res.data

            this.$emit('item-stock-updated', {
              stock: stock,
              ordered_quantity: ordered_quantity
            })
            this.loading = false
            this.retryPingCount = 0
          } else {
            setTimeout(() => this.ping(), 5000)
          }
        })
        .catch(e => console.log(e))
    },
    ping () {
      if (this.processing) { return }
      this.processing = true
      this.loading = true
      // console.log('Pinging warehouses')
      this.$http.get(`/api/production/products/${this.item.id}/fetch_warehouses`, {
        params: {
          fetch_sap: this.retryPingCount == 5 ? true : false
        }
      })
        .then((res) => {
          // console.log(res)
          if (res.data.success) {
            this.warehouses = res.data.warehouses
            this.timestamp = res.data.timestamp

            const { stock, ordered_quantity } = res.data
            this.$emit('item-stock-updated', {
              stock: stock,
              ordered_quantity: ordered_quantity
            })
            this.loading = false
            this.pendingResult = false
          } else {
            this.retryPingCount+=1
            if (this.retryPingCount == 10) {
              this.loading = false
              this.pendingResult = true
              this.retryPingCount = 0
              return
            }
            setTimeout(() => this.ping(), 5000)
          }
        })
        .catch(e => console.log(e))
        .finally(() => {
          this.processing = false
        })
    },
    reset () {
      this.warehouses = []
      this.timestamp = null
      this.loading = false
      this.processing = false
      this.pendingResult = false
    }
  }
}
</script>
